import VForm from "@/vuetify_custom/v-form";
import VModel from "@/vuetify_custom/v-modal_v1";
import EditAttachments from "@/views/components/file/edit_attachments_v1";
import FileUploader from "@/views/components/file/uploader.vue";
import { SPULevel, SPU_SELECT_SPLITER, SPU_TYPE, SPU_VERSION_TYPE, trackList } from "../../constants";
import { addSpu, getEnumConfigListApi } from "../../service";
function createParams(params) {
  return {
    id: params.id || null, // spu id ,为空则为新建
    spu_name: params.spu_name || null, // spu 名称
    company_level:
      params.company_level !== undefined ? params.company_level : false, // 是否为公司级
    product_family: params.product_family || null, // PF
    business_unit: params.business_unit
      ? params.business_unit.split(",")
      : null, // BU
    track: params.track ? params.track.split(",") : null, // 赛道
    research_team_id: params.research_team_id || null, // 研发团队 id
    sale_team_id: params.sale_team_id || null, // 市运销团队 id
    approve_begin_at: params.approve_begin_at || null, // 预计立项时间 开始
    approve_end_at: params.approve_end_at || null, // 预计立项时间 结束
    launch_begin_at: params.launch_begin_at || null, // 预计上市时间 开始
    launch_end_at: params.launch_end_at || null, // 预计上市时间 结束
    remark: params.remark || null,
    bfiles: params.bfiles || [],
    type: params.type || null,
    edition: params.edition || 1,
    uid: params.uid || null,
    origin_spu: null
    // ...params
  };
}
export default {
  data() {
    return {
      dis: false,
      submitLoading: false,
      params: createParams({}),
      pfList: [],
      buList: [],
    };
  },
  computed: {
    baseInforFields() {
      const d = [(val) => !!val || "必选"];
      const arr = [
        {
          hide: this.params.id ? true : false,
          label: "",
          type: "radio_buttons",
          key: "edition",
          cols: 12,
          required: true,
          inline: true,
          row: true,
          items: SPU_VERSION_TYPE,
          rules: [(val) => !["", undefined, null].includes(val) || '必选'],
        },
        {
          label: "SPU",
          key: "spu_name",
          cols: 12,
          rules: d,
          required: true,
          hide: this.params.edition === 2 && !this.params.id,
          disabled: this.params.edition === 2 && this.params.id,
        },
        {
          label: 'SPU',
          key:'origin_spu',
          type:'autocompletes_async_v1',
          'item-value':'select_value',
          'item-text':'spu_name',
          api: this.$util.api.cya_spu_select_edition,
          cols: 12,
          handle_data:(data) => {
           return Array.isArray(data) ? data.map(item => ({...item, select_value: item.uid + SPU_SELECT_SPLITER + item.spu_name})) : []
          },
          rules: d,
          clearable:true,
          hide: this.params.edition === 1 || this.params.id,
          disabled: this.params.id ? true : false,
          change: (v) => {
            if (v) {
              const arr = v.split(SPU_SELECT_SPLITER)
              this.params.uid = arr[0] || ''
              this.params.spu_name = arr[1] || ''
            } else {
              this.params.uid = null
              this.params.spu_name = null
            }
            
          }
        },
        {
          label: "PF",
          type: "select_field",
          key: "product_family",
          // 'item-text': 'label',
          // 'item-value': 'value',
          cols: 12,
          required: true,
          items: this.pfList,
          rules: d,
        },
        {
          label: "Business Unit",
          type: "select_field",
          key: "business_unit",
          // 'item-text': 'label',
          // 'item-value': 'value',
          cols: 12,
          multiple: true,
          required: true,
          items: this.buList,
          rules: d,
        },
        {
          label: "SPU等级",
          type: "select_field",
          key: "company_level",
          "item-text": "label",
          "item-value": "value",
          cols: 12,
          required: true,
          items: SPULevel,
          rules: [(val) => val === true || val === false || "必选"],
        },
        {
          label: "类型",
          type: "select_field",
          key: "type",
          "item-text": "label",
          "item-value": "value",
          cols: 12,
          rules: d,
          required: true,
          items: SPU_TYPE,
        },
        {
          label: "所属赛道",
          type: "select_field",
          key: "track",
          cols: 12,
          multiple: true,
          rules: d,
          required: true,
          items: trackList,
        },
        {
          label: "研发团队",
          type: "team_select",
          key: "research_team_id",
          cols: 12,
          rules: d,
          required: true,
        },
        {
          label: "市运销团队",
          type: "team_select",
          key: "sale_team_id",
          cols: 12,
          rules: d,
          required: true,
        },
        {
          label: "预计立项时间",
          type: "date_range",
          key: "setupTime",
          start_key: "approve_begin_at",
          end_key: "approve_end_at",
          cols: 12,
          required: true,
          rules: [
            (val) => {
              if (val && val.length < 2) {
                return "需要选择时间段";
              }
              if (val && val.length === 2) {
                return true;
              }
              return "必选";
            },
          ],
        },
        {
          label: "预计上市时间",
          type: "date_range",
          key: "marketTime",
          start_key: "launch_begin_at",
          end_key: "launch_end_at",
          cols: 12,
          required: true,
          rules: [
            (val) => {
              if (val && val.length < 2) {
                return "需要选择时间段";
              }
              if (val && val.length === 2) {
                return true;
              }
              return "必选";
            },
          ],
        },
        {
          label: "备注",
          type: "text_field",
          key: "remark",
          cols: 12,
        },
        {
          label: "附件",
          key: "bfiles",
          cols: 12,
        },
      ];
      return arr.filter(item => !item.hide);
    },
  },
  mounted() {
    // 初始化选择列表
    getEnumConfigListApi({ enum_type: "pf", del: false }).then((res) => {
      res = res || [];
      this.pfList = res.map((item) => item.enum_value);
    });
    getEnumConfigListApi({ enum_type: "bu", del: false }).then((res) => {
      res = res || [];
      this.buList = res.map((item) => item.enum_value);
    });
    // querySpuList
  },
  methods: {
    edit(params) {
      this.dis = true;
      this.params = createParams(params);
    },
    submit() {
      if (
        !(
          this.$refs.base &&
          this.$refs.base.validate &&
          this.$refs.base.validate()
        )
      ) {
        return;
      }
      this.submitLoading = true;
      addSpu({
        ...this.params,
        business_unit: this.params.business_unit.join(","),
        track: this.params.track.join(","),
      })
        .then(() => {
          this.dis = false;
          this.$emit("success");
          this.$Message.success("保存成功！");
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
  },
  render() {
    return (
      <VModel
        v-model={this.dis}
        persistent
        dynamic-height
        height-rate={0.7}
        title={this.params.id ? "编辑" : "新建"}
        max-width="1000"
        loading={this.submitLoading}
        on={{
          ok: this.submit,
          // cancel: _this.cancel
        }}
      >
        <VForm
          ref="base"
          v-model={this.params}
          fields={this.baseInforFields}
          scopedSlots={{
            // bfiles:({field} = {}) => {
            bfiles: () => {
              return (
                <div style="display:flex">
                  <p style="width:40px">附件</p>
                  <div style="flex:1">
                    <EditAttachments
                      files={this.params.bfiles}
                      modelType="Contract"
                      modelId={this.params.id}
                    />
                    <FileUploader
                      validateFile={(file) => {
                        const a = /\.[0-9a-zA-Z]+$/.test(file.name);
                        if (!a) {
                          this.$vModal.warning({
                            title: "提示",
                            content:
                              "文件格式错误，无法解析。建议上传如下类型：.xlsx、.pdf等带有后缀的",
                          });
                        }
                        return a;
                      }}
                      on={{
                        uploaded: (bfile) => {
                          this.params.bfiles.push(bfile);
                        },
                      }}
                    />
                    <span class="color-error">
                      为保证兼容性及文档可编辑性，请上传office系列的文档(Word,
                      Excel, PPT)
                    </span>
                  </div>
                </div>
              );
            },
          }}
        />
      </VModel>
    );
  },
};
